import styled, { css } from 'styled-components';

const Input = styled.input<{iconL?: boolean, iconR?: boolean, low?: boolean}>`
  background: #FFFFFF;
  border: 1px solid #D3D4D5;
  border-radius: 8px;
  width: 100%;
  height: 48px;
  padding: 12px;
  font-size: 18px;
  box-sizing: border-box;
  font-family: unset;

  ${(props) => props.low && css`
    height: 40px;
    padding: 8px 12px;
  `}

  padding-left: ${(props) => (props.iconL ? '44px' : '12px')};
  padding-right: ${(props) => (props.iconR ? '44px' : '12px')};

  ::placeholder { 
    color: var(--color-charcoal-v40);
  }

  &:focus::placeholder {
    color: transparent;
  }
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 15px;
  line-height: 1.3;
  font-weight: 600;
  gap: 8px;
  width: 100%;
  color: var(--color-charcoal-v50);
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  width: 36px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  left: 6px;

  &.r {
    left: unset;
    right: 6px;
  }
`;

export const InputButton = styled.button`
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 150ms;
  pointer-events: all;
  border: none;
  height: 36px;
  width: 36px;
  background-color: transparent;

  &:hover {
    background-color: var(--color-bluescape-v10);
  }

  &:active {
    background-color: var(--color-bluescape-v05);
  }
`;

export const InputWithIcon = ({
  iconR, iconL, low, ...props
}: {
  iconR?: React.ReactNode,
  iconL?: React.ReactNode,
  low?: boolean,
} & React.InputHTMLAttributes<HTMLInputElement>) => (
  <InputContainer>
    {iconL && <IconContainer>{iconL}</IconContainer>}
    <Input low={low} iconL={!!iconL} iconR={!!iconR} {...props} />
    {iconR && <IconContainer className="r">{iconR}</IconContainer>}
  </InputContainer>
);

export default Input;
